import App from './app';

import Broadband from '../app/broadband';
import Akasse from '../app/akasse';
import CellphoneSubscription from '../app/cellphone/subscription';
import CellphonePrepaid from '../app/cellphone/prepaid';
import loan from '../app/loan/loan';
import consumerloan from '../app/loan/consumerloan';
import Tv from '../app/tv';
import Mbb from '../app/mbb';
import Webhotel from '../app/webhotel';
import Streaming from '../app/streaming';
import Mealbox from '../app/mealbox';
import Vpn from '../app/vpn';

import NotFound from '../app/static-pages/not-found';

export default [
  {
    component: App,
    routes: [
      { path: '/', component: NotFound, exact: true },

      { path: '/lån', component: loan, exact: true },
      { path: '/lån/:filter', component: loan, exact: true },
      { path: '/lan', component: loan, exact: true },
      { path: '/lan/:filter', component: loan, exact: true },
      { path: '/laan', component: loan, exact: true },
      { path: '/laan/:filter', component: loan, exact: true },

      { path: '/forbrugslån', component: consumerloan, exact: true },
      { path: '/forbrugslån/:filter', component: consumerloan, exact: true },
      { path: '/forbrugslaan', component: consumerloan, exact: true },
      { path: '/forbrugslaan/:filter', component: consumerloan, exact: true },

      // <Redirect exact from={encodeURI('/kviklån')} to={encodeURI('/lån')} />
      // <Redirect exact from="/kviklaan" to={encodeURI('/lån')} />

      { path: '/a-kasse', component: Akasse, exact: true },
      { path: '/a-kasse/:filter', component: Akasse, exact: true },
      { path: '/akasse', component: Akasse, exact: true },
      { path: '/akasse/:filter', component: Akasse, exact: true },

      { path: '/bredbånd', component: Broadband, exact: true },
      { path: '/bredbånd/:filter', component: Broadband, exact: true },
      { path: '/bredband', component: Broadband, exact: true },
      { path: '/bredband/:filter', component: Broadband, exact: true },
      { path: '/bredbaand', component: Broadband, exact: true },
      { path: '/bredbaand/:filter', component: Broadband, exact: true },

      { path: '/mobilabonnement', component: CellphoneSubscription, exact: true },
      { path: '/mobilabonnement/:filter', component: CellphoneSubscription, exact: true },
      
      { path: '/taletidskort', component: CellphonePrepaid, exact: true },

      { path: '/tv-udbydere', component: Tv, exact: true },
      { path: '/tv-udbydere/:filter', component: Tv, exact: true },
      
      { path: '/webhotel', component: Webhotel, exact: true },
      { path: '/webhotel/:filter', component: Webhotel, exact: true },

      { path: '/vpn', component: Vpn, exact: true },
      { path: '/vpn/:filter', component: Vpn, exact: true },

      { path: '/streaming', component: Streaming, exact: true },
      { path: '/streaming/:filter', component: Streaming, exact: true },
      
      { path: '/mealbox', component: Mealbox, exact: true },
      { path: '/mealbox/:filter', component: Mealbox, exact: true },
      { path: '/måltidskasse', component: Mealbox, exact: true },
      { path: '/måltidskasse/:filter', component: Mealbox, exact: true },
      { path: '/maaltidskasse', component: Mealbox, exact: true },
      { path: '/maaltidskasse/:filter', component: Mealbox, exact: true },

      { path: '/mobil-bredbånd', component: Mbb, exact: true },
      { path: '/mobil-bredbånd/:filter', component: Mbb, exact: true },
      { path: '/mobil-bredband', component: Mbb, exact: true },
      { path: '/mobil-bredband/:filter', component: Mbb, exact: true },
      { path: '/mobil-bredbaand', component: Mbb, exact: true },
      { path: '/mobil-bredbaand/:filter', component: Mbb, exact: true },

      { path: '/mobilbredbånd', component: Mbb, exact: true },
      { path: '/mobilbredbånd/:filter', component: Mbb, exact: true },
      { path: '/mobilbredband', component: Mbb, exact: true },
      { path: '/mobilbredband/:filter', component: Mbb, exact: true },
      { path: '/mobilbredbaand', component: Mbb, exact: true },
      { path: '/mobilbredbaand/:filter', component: Mbb, exact: true },

      { path: '/mobilt-bredbånd', component: Mbb, exact: true },
      { path: '/mobilt-bredbånd/:filter', component: Mbb, exact: true },
      { path: '/mobilt-bredband', component: Mbb, exact: true },
      { path: '/mobilt-bredband/:filter', component: Mbb, exact: true },
      { path: '/mobilt-bredbaand', component: Mbb, exact: true },
      { path: '/mobilt-bredbaand/:filter', component: Mbb, exact: true },

      { path: '/mobiltbredbånd', component: Mbb, exact: true },
      { path: '/mobiltbredbånd/:filter', component: Mbb, exact: true },
      { path: '/mobiltbredband', component: Mbb, exact: true },
      { path: '/mobiltbredband/:filter', component: Mbb, exact: true },
      { path: '/mobiltbredbaand', component: Mbb, exact: true },
      { path: '/mobiltbredbaand/:filter', component: Mbb, exact: true },

      { component: NotFound, status: 404 }
    ]
  }
];